// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* .row {
    display: flex;
	justify-content: flex-start;
	align-items: center;
    gap: 10px;
	min-height: 26px;
	flex-wrap: wrap;
}


.row > button {
	height: 24px;
}
 */



.row {
    display: flex;
	justify-content: flex-start;
	align-items: center;
    gap: 10px;
	min-height: 26px;
	flex-wrap: wrap;
    width: 100%;
}


.row > button {
	height: 24px;
}`, "",{"version":3,"sources":["webpack://./code/styles/row.css"],"names":[],"mappings":";;AAEA;;;;;;;;;;;;;EAaE;;;;AAIF;IACI,aAAa;CAChB,2BAA2B;CAC3B,mBAAmB;IAChB,SAAS;CACZ,gBAAgB;CAChB,eAAe;IACZ,WAAW;AACf;;;AAGA;CACC,YAAY;AACb","sourcesContent":["\n\n/* .row {\n    display: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n    gap: 10px;\n\tmin-height: 26px;\n\tflex-wrap: wrap;\n}\n\n\n.row > button {\n\theight: 24px;\n}\n */\n\n\n\n.row {\n    display: flex;\n\tjustify-content: flex-start;\n\talign-items: center;\n    gap: 10px;\n\tmin-height: 26px;\n\tflex-wrap: wrap;\n    width: 100%;\n}\n\n\n.row > button {\n\theight: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
